export const darkTheme = {
  bg: "#181818",
  sidebarBg: "#202020",
  text: "white",
  textSoft: "#aaaaaa",
  softHr: "#373737",
};

export const lightTheme = {
  bg: "#f9f9f9",
  sidebarBg: "white",
  text: "black",
  textSoft: "#606060",
  softHr: "#f5f5f5",
};
